{
  "Add to Calendar": "Add to Calendar",
  "An email confirmation has been sent to": "An email confirmation has been sent to",
  "Any Provider (No preference)": "Any Provider (No preference)",
  "Appointment Booked": "Appointment Booked",
  "Back": "Back",
  "Book Another Appointment": "Book Another Appointment",
  "Booking progress": "Booking progress",
  "Call or text us at": "Call or text us at",
  "Call the Practice": "Call the Practice",
  "Cancellation Policy": "Cancellation Policy",
  "Continue": "Continue",
  "Date and Time": "Date and Time",
  "Location": "Location",
  "Next availability:": "Next availability:",
  "Or select a specific provider": "Or select a specific provider",
  "Payment Received": "Payment Received",
  "Provider": "Provider",
  "Questions about your request?": "Questions about your request?",
  "Requested Date and Time": "Requested Date and Time",
  "Requested Provider": "Requested Provider",
  "Requested Service": "Requested Service",
  "Scheduling powered by": "Scheduling powered by",
  "Select a location": "Select a location",
  "Select a provider": "Select a provider",
  "Service": "Service",
  "Service Type": "Service Type",
  "Something went wrong on our end and your appointment was not booked.": "Something went wrong on our end and your appointment was not booked.",
  "Start Over": "Start Over",
  "We couldn't complete your booking.": "We couldn't complete your booking.",
  "What can we help you with?": "What can we help you with?",
  "You were away for a bit, so we ended your session. Nothing was saved.": "You were away for a bit, so we ended your session. Nothing was saved.",
  "You will be sent a confirmation SMS to": "You will be sent a confirmation SMS to",
  "You're almost there, {{locationName}} will get back to you to confirm your appointment": "You're almost there, {{locationName}} will get back to you to confirm your appointment",
  "Your session has expired": "Your session has expired",
  "pages": "pages",
  "{{amount}} received for {{serviceName}}": "{{amount}} received for {{serviceName}}"
}
